import { Breakpoint, ResponsiveProp } from './skeleton-grid.types';

/**
 * Resolves a responsive property to a concrete value based on the current active breakpoint.
 * It cascades downwards to find the most suitable activated breakpoint, honoring
 * desktop-first fallback for missing intermediatory sizes, or standard mobile-first
 * fallbacks down to the default value.
 */
export function resolveResponsiveProp(
  prop: ResponsiveProp | undefined,
  bp: Breakpoint,
  fallback: string | number
): string | number {
  if (prop === undefined || prop === null) return fallback;
  if (typeof prop === 'string') return prop;
  if (typeof prop === 'number') return `var(--spacing-${prop}, ${prop * 4}px)`;

  // It's a config object. Cascade down from the currently active breakpoint.
  if (bp === 'xl') {
    if (prop.xl !== undefined) return prop.xl;
    if (prop.lg !== undefined) return prop.lg;
    if (prop.md !== undefined) return prop.md;
    if (prop.sm !== undefined) return prop.sm;
    if (prop.xs !== undefined) return prop.xs;
  }

  if (bp === 'lg') {
    if (prop.lg !== undefined) return prop.lg;
    if (prop.md !== undefined) return prop.md;
    if (prop.sm !== undefined) return prop.sm;
    if (prop.xs !== undefined) return prop.xs;
  }

  if (bp === 'md') {
    if (prop.md !== undefined) return prop.md;
    if (prop.sm !== undefined) return prop.sm;
    if (prop.xs !== undefined) return prop.xs;
  }

  if (bp === 'sm') {
    if (prop.sm !== undefined) return prop.sm;
    if (prop.xs !== undefined) return prop.xs;
  }

  if (bp === 'xs') {
    if (prop.xs !== undefined) return prop.xs;
  }

  // Fallback to default if explicitly provided, else the main fallback
  if (prop.default !== undefined) return prop.default;

  return fallback;
}
